import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function AssignViewLearner(props) {
  const classes = useStyles();
  const {
    menuProps,
    center,
    selectedCenter,
    handleCenterChange,
    cources,
    selectedCource,
    handleCourceChange,
    selectedBatch,
    handleBatchChange,
    batches,
    columns,
    filteredRows,
    handleCheckboxClick,
    handleStatus,
    GivingExam,
  } = props;
  const Heading = [
    {
      height: "maxh52",
      style: "viewtable",
      checkboxselection: "true",
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
        className={` ${classes.w100} ${classes.alignitemscenter} ${classes.p1} ${classes.borderradius6px} ${classes.inputpadding} ${classes.inputborder} ${classes.inputplaceholdercolorblack} ${classes.dflex}`}
      >
        <Typography
          variant="h5"
          className={`${classes.fontsize4} ${classes.fw600}`}
        >
          Assign To
        </Typography>
        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="category-label"
            id="state"
            value={selectedCenter}
            onChange={handleCenterChange}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Branch</em>
            </MenuItem>
            {center &&
              center.map((st) => (
                <MenuItem key={st.id} value={st.id}>
                  {st?.center_code} - {st?.center_name}
                </MenuItem>
              ))}
          </Select> */}

          <Autocomplete
            id="branch-autocomplete"
            options={center || []}
            getOptionLabel={(option) =>
              option?.center_code
                ? `${option?.center_code} - ${option?.center_name}`
                : option?.center_name || ""
            }
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={center?.find((st) => st.id === selectedCenter) || null}
            onChange={handleCenterChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Branch"
                variant="outlined"
              />
            )}
          />
        </div>

        <div
          className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="category-label"
            id="state"
            value={selectedCource}
            onChange={handleCourceChange}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Course</em>
            </MenuItem>
            {cources?.map((data, index) => {
              return (
                <MenuItem key={index} value={data.id}>
                  {data.course_name}
                </MenuItem>
              );
            })}
          </Select> */}

          <Autocomplete
            id="course-autocomplete"
            options={cources || []}
            getOptionLabel={(option) => option?.course_name || ""}
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={cources?.find((data) => data.id === selectedCource) || null}
            onChange={handleCourceChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Course"
                variant="outlined"
              />
            )}
          />
        </div>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="category-label"
            id="state"
            value={selectedBatch}
            onChange={handleBatchChange}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Batch</em>
            </MenuItem>
            {batches?.map((data, index) => {
              return (
                <MenuItem key={index} value={data.id}>
                  {data.batch_name}
                </MenuItem>
              );
            })}
          </Select> */}

          <Autocomplete
            id="batch-autocomplete"
            options={batches || []}
            getOptionLabel={(option) => option?.batch_name || ""}
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={batches?.find((data) => data.id === selectedBatch) || null}
            onChange={handleBatchChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Batch"
                variant="outlined"
              />
            )}
          />
        </div>
      </div>
      <div
        className={`${classes.bgwhite} ${classes.dflex} ${classes.flexdirectioncolumn} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}`}
      >
        <TableView
          columns={columns}
          rows={filteredRows}
          Heading={GivingExam}
          onCheckboxClick={handleCheckboxClick}
        />
      </div>
    </>
  );
}
export default AssignViewLearner;
